import StatusHandler from 'app/shared-components/StatusHandler'

import useGetLongTermLease from '../hooks/useGetLongTermLease'
import LongTermLeaseForm from '../LongTermLeaseForm'

const LongTermLeaseUpdate = ({
    id,
}: Readonly<{
    id: number
}>) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
    } = useGetLongTermLease(id)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <LongTermLeaseForm data={data} />
        </StatusHandler>
    )
}

export default LongTermLeaseUpdate
